import React from 'react'

const Facebook = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00201 12.0018C2.00258 14.3832 2.85249 16.6862 4.39898 18.497C5.94547 20.3078 8.08713 21.5076 10.439 21.8808V14.8918H7.90201V12.0018H10.442V9.80184C10.3859 9.28693 10.4439 8.76598 10.6118 8.276C10.7798 7.78602 11.0535 7.33903 11.4137 6.96677C11.7738 6.59451 12.2115 6.30611 12.6956 6.12206C13.1798 5.93801 13.6985 5.86282 14.215 5.90184C14.965 5.91384 15.715 5.98084 16.455 6.10184V8.56084H15.191C14.9762 8.5327 14.7578 8.5532 14.5519 8.62082C14.3461 8.68844 14.1581 8.80145 14.0018 8.9515C13.8455 9.10156 13.7249 9.28481 13.649 9.48773C13.573 9.69065 13.5436 9.90804 13.563 10.1238V12.0018H16.334L15.891 14.8928H13.563V21.8808C15.4506 21.5825 17.2132 20.7496 18.6422 19.4806C20.0711 18.2116 21.1065 16.5598 21.6258 14.7207C22.145 12.8815 22.1265 10.9321 21.5722 9.10317C21.018 7.27426 19.9512 5.64247 18.4984 4.40098C17.0455 3.15949 15.2673 2.36031 13.3744 2.09804C11.4814 1.83578 9.55293 2.12141 7.81727 2.92114C6.0816 3.72086 4.61143 5.00118 3.58082 6.61051C2.55021 8.21985 2.00232 10.0908 2.00201 12.0018Z"
        fill="#335BA6"
      />
    </svg>
  )
}

export default Facebook
